import axios from "axios";
import settings from "utils/settings";
import scheduleMods from "data/schedule-mods";

const { apiUrl } = settings;

const scheduleRequestPramsCorrector = (requestParams, hasPagination = true) => ({
    ...(hasPagination && {
        pageNumber: requestParams.pageNumber,
        pageSize: requestParams.pageSize,
    }),
    sortOptions: requestParams.sortOptions || (hasPagination ? null : {earliestDate: true}),
    includeFilterLists: true,
    provinceIds: requestParams.provinceIds || null,
    cityIds: requestParams.cityIds || null,
    storeIds: requestParams.storeIds || null,
    retailerIds: requestParams.retailerIds || null,
    jobIds: requestParams.jobIds || null,
    productIds: requestParams.productIds || null,
    traits: requestParams.traits || null,
    hours: requestParams.hours || null,
    merchandiserIds: requestParams.merchandiserIds || null,
    supervisorIds: requestParams.supervisorIds || null,
    startDate: requestParams.earliestDate || null,
    endDate: requestParams.latestDate || null,
    accountManagerIds: requestParams.accountManagerIds || null,
    mode: requestParams.mode || scheduleMods.NotActivated.value,
    category: requestParams.category || "All",
    exceptions: requestParams.exceptions || null,
    serviceConfirmation: requestParams.serviceConfirmation || null
});

export const scheduleGetPaged = (requestParams) =>
    axios.post(`${apiUrl}schedule`, scheduleRequestPramsCorrector(requestParams));

export const scheduleGetMapView = (requestParams) =>
    axios.post(`${apiUrl}map/view`, scheduleRequestPramsCorrector(requestParams, false));

export const scheduleActivate = (filter, serviceId) => {
    if (serviceId) {
        filter.serviceId = serviceId;
    }
    if (filter.earliestDate) {
        filter.startDate = filter.earliestDate;
        delete filter.earliestDate;
    }
    if (filter.latestDate) {
        filter.endDate = filter.latestDate;
        delete filter.latestDate;
    }
    return axios.post(`${apiUrl}schedule/activate`, filter);
};

export const scheduleDeactivate = (filter, serviceId) => {
    if (serviceId) {
        filter.serviceId = serviceId;
    }
    if (filter.earliestDate) {
        filter.startDate = filter.earliestDate;
        delete filter.earliestDate;
    }
    if (filter.latestDate) {
        filter.endDate = filter.latestDate;
        delete filter.latestDate;
    }
    return axios.post(`${apiUrl}schedule/deactivate`, filter);
};

export const requestScheduleExport = (filter) => {
    if (filter.earliestDate) {
        filter.startDate = filter.earliestDate;
        delete filter.earliestDate;
    }
    if (filter.latestDate) {
        filter.endDate = filter.latestDate;
        delete filter.latestDate;
    }

    return axios.post(`${apiUrl}schedule/export/excel`, filter, {
        responseType: "blob"
    });
};

export const scheduleDelete = (data) =>
    axios.delete(`${apiUrl}schedule`, { data });

export const schedulePatch = (filter, data) => {
    const defaultData = {
        timeLimit: null,
        earliestDate: null,
        latestDate: null,
        merchandiserId: null,
        acctManagerId: null,
        serviceTypeId: null,
        consumerGroupId: null,
        payrate: null,
        trait: null,
        markMerchandiserAsTemporary: false,
        sendBackup: false,
        filter
    };
    Object.keys(data).forEach(key => {
        defaultData[key] = data[key];
    });
    return axios.patch(`${apiUrl}schedule/batch`, defaultData);
};

export const methodPatchScheduling = (serviceId, data) => {
    const defaultData = {
        serviceId,
        merchandiserId: null,
        timeLimit: null,
        earliestDate: null,
        latestDate: null,
        acctManagerId: null,
        serviceTypeId: null,
        consumerGroupId: null,
        payrate: null,
        trait: null,
        markMerchandiserAsTemporary: false,
        sendBackup: false
    };

    Object.keys(data).forEach(key => {
        defaultData[key] = data[key];
    });
    return axios.patch(`${apiUrl}schedule`, defaultData);
};

export const methodHighlightSchedule = (requestData) =>
    axios.post(`${apiUrl}schedule/highlight`, requestData);

export const methodAddService = (data) => axios.post(`${apiUrl}schedule/addService`, data);

export const methodGetScheduleEmails = (requestData) =>
    axios.post(`${apiUrl}schedule/email`, requestData);

export const methodGetServiceConfirmation = (serviceId) =>
    axios.get(`${apiUrl}schedule/confirmations/${serviceId}`);

export const methodPostServiceConfirmation = (serviceId, data) =>
    axios.post(`${apiUrl}schedule/confirmations/${serviceId}`, data);

export const methodPutServiceConfirmation = (serviceId, data) =>
    axios.put(`${apiUrl}schedule/confirmations/${serviceId}`, data);

export const methodDeleteServiceConfirmation = (serviceId) =>
    axios.delete(`${apiUrl}schedule/confirmations/${serviceId}`);

export const scheduleToggleAutoTravelExclusion = (serviceId, exclude) =>
    axios.put(`${apiUrl}AutoTravelCharges/exclusion/${serviceId}`, { exclude });